/* eslint-disable class-methods-use-this */
import WidgetStateMachine from './WidgetStateMachine';
import WidgetTypes from './enums/WidgetTypes';
import LiveChatBase from './LiveChatBase';
import TempCache from './enums/TempCache';
import GlobalVariables from './GlobalVariables';
import TimeType from './hooks/TimeType';
import log from './hooks/log';
import {
    AgentScriptActionType,
    ChatState,
    ScriptsQuestionType,
    SkinInviteType
} from './enums/Enum';
import TrackData from './hooks/TrackData';
import trackTime from './hooks/trackTime';
import checkSpanishLanguage from './hooks/checkSpanishLanguage';
import WebStorage from './hooks/WebStorage';
import Browser from './hooks/Browser';
import ServerLog from './hooks/ServerLog';
import getGaClientId from './hooks/getGaClientId';
import RunAsSoonAs from './hooks/RunAsSoonAs';
import ScriptsQuestionTypeToolTips from './hooks/ScriptsQuestionTypeToolTips';
import Cookies from './hooks/Cookies';
import getCookieValue from './hooks/getCookieValue';
import getStorageAPIValue from './hooks/getStorageAPIValue';
import storageAPIExists from './hooks/storageAPIExists';

export default class BaseClass extends LiveChatBase {
    constructor(options) {
        super(options);
        this.options = options;

        GlobalVariables.ApexChatDefaultLogLevel = options.ApexChatDefaultLogLevel
            ? options.ApexChatDefaultLogLevel
            : GlobalVariables.ApexChatDefaultLogLevel;
        var me = this;
        if (typeof ApexChat.ApexChatJquery === 'function') {
            me.$ = ApexChat.ApexChatJquery;
        }
        // we hand over all state management to a dedicated object - hence unified
        this.state = new WidgetStateMachine({
            widget: options.widget,
            logger: options.logger
                ? options.logger
                : {
                    name: 'ApexChat.log',
                    log(logOptions) {
                        // {logWhere:client|server|both,level:LogLevel,text:text,companyId:,visitorId}
                        if (logOptions.logWhere === 'client') {
                            log(
                                logOptions.level ? logOptions.level : ApexChatDefaultLogLevel,
                                logOptions.text
                            );
                        } else if (logOptions.logWhere === 'server') {
                            ServerLog.log({
                                level: logOptions.level
                                    ? logOptions.level
                                    : ApexChatDefaultLogLevel,
                                visitorId: logOptions.visitorId,
                                companyId: logOptions.companyId,
                                text: logOptions.text
                            });
                        } else {
                            // if (options.logWhere == 'both') {
                            log(
                                logOptions.text,
                                logOptions.level
                                    ? logOptions.level
                                    : GlobalVariables.ApexChatDefaultLogLevel
                            );
                        }
                    }
                },
            analytics: options.analytics
                ? options.analytics
                : {
                    name: 'ApexChat.track',
                    track: TrackData,
                    trackTime
                },
            storage: options.storage
                ? options.storage
                : {
                    name: 'WebStorage',
                    api: WebStorage()
                },
            onStateChanged(args) {
                me.postMessage(args);
            }
        });
        this.companyId = options.companyId;
        this.lastWindowWidth = 0;
        this.lastScrollLeft = 0;
        this.lastScrollTop = 0;
        this.pinchZoomed = false;
        this.initialScale = false;
        this.startTouchTop = -1;
        this.invitationHeight = 0;
        this.wiggleAnimation = null;
        this.initialDisplayAnimation = null;
        this.interceptorResults = null;
        // this.agentName = (this.options.agentName) ?
        //    this.options.agentName.charAt(0).toUpperCase() + this.options.agentName.substring(1):
        //    this.options.model.agentName.charAt(0).toUpperCase() + this.options.model.agentName.substring(1);
        this.mobileInvitation = {
            positionUsed: null,
            originalStyles: null,
            zoom: 1,
            viewZoom: 1
        };
        this.tabbedInvitation = {
            invitationTravel: 0,
            travelProperty: 'bottom',
            animatingTab: false,
            borderTopRadius: [
                'webkitBorderTopRightRadius',
                'webkitBorderTopLeftRadius',
                'mozBorderRadiusTopright',
                'mozBorderRadiusTopleft',
                'borderTopRightRadius',
                'borderTopLeftRadius'
            ],
            borderBottomRadius: [
                'webkitBorderBottomRightRadius',
                'webkitBorderBottomLeftRadius',
                'mozBorderRadiusBottomright',
                'mozBorderRadiusBottomleft',
                'borderBottomRightRadius',
                'borderBottomLeftRadius'
            ],
            borderLeftRadius: [
                'webkitBorderTopLeftRadius',
                'webkitBorderBottomLeftRadius',
                'mozBorderRadiusTopleft',
                'mozBorderRadiusBottomleft',
                'borderTopLeftRadius',
                'borderBottomLeftRadius'
            ],
            borderRightRadius: [
                'webkitBorderTopRightRadius',
                'webkitBorderBottomRightRadius',
                'mozBorderRadiusTopright',
                'mozBorderRadiusBottomright',
                'borderTopRightRadius',
                'borderBottomRightRadius'
            ],
            defaultStyles: [
                '#apexchat_invitation_container_wrapper .tabbed > div > div {',
                '   -webkit-border-top-right-radius: 0px;',
                '   -webkit-border-top-left-radius: 0px;',
                '   -moz-border-radius-topright: 0px;',
                '   -moz-border-radius-topleft: 0px;',
                '   border-top-right-radius: 0px;',
                '   border-top-left-radius: 0px;',
                '}',
                '#apexchat_invitation_container_wrapper div.apexchat_invitation_tab {',
                '   box-shadow: none;',
                '   -webkit-box-shadow: none;',
                '   width: 100%;',
                '   bottom: 100%;',
                '   text-align: center;',
                '   position: absolute;',
                '   margin: 0px;',
                '   cursor: pointer;',
                '   padding: 0px;',
                '}'
            ].join('\n')
        };
        var me = this;
        // me.$ = ApexChat.ApexChatJquery;
        me.extend_$();
    }

    // equivalent to ApexChat.fire
    postMessage(e) {
        // var evt = JSON.parse(JSON.stringify(e));
        this.publish(e);
    }

    isPageRefreshed() {
        // we detect subsequent page reloads based on this
        const yes = getStorageAPIValue(TempCache.IS_PAGE_REFRESHED) === 'true';
        return yes;
    }

    isChatClosed() {
        return getCookieValue(TempCache.CHAT_STATE) == ChatState.Closed;
    }

    getPhoneMessage() {
        const phoneNumber = ApexChat.localStorageAPI.Get(TempCache.VISITOR_PHONE);
        return {
            phone: phoneNumber
        };
    }

    extractPhoneNumberFromText(text) {
        let phone = '';
        const regexPattern = /\(?\b\s?\+?([0-9-.+( ))]{7,18})/g;
        const matches = text.match(regexPattern);
        if (!matches) {
            return;
        }
        for (let i = 0; i < matches.length; i++) {
            phone = matches[i].replace(/[{}]/g, '');
        }
        return phone.replace(/[^\d\+x]/g, '');
    }

    savePhoneNumber(phoneText) {
        const phone = this.extractPhoneNumberFromText(phoneText);
        ApexChat.localStorageAPI.Store(TempCache.VISITOR_PHONE, phone);
    }

    getChatId() {
        return this.options.chatId || ApexChat.TryParse(getCookieValue(TempCache.CHAT_ID_COOKIE));
    }

    getChatToken() {
        return ApexChat.TryParse(getCookieValue(TempCache.CHAT_TOKEN_COOKIE));
    }

    isChatActive() {
        return storageAPIExists(TempCache.CHAT_ID_COOKIE);
    }

    isRDEP() {
        const me = this;
        return me.widget === WidgetTypes.EPUIController;
    }

    getQueryString(chatMode, getGuid, languageOverride, additionalParams) {
        const me = this;
        let linkerParam = '_ga=';
        let visitorGaClientId = '';
        if (typeof ga === 'function') {
            try {
                linkerParam = ga.getAll()[0].get('linkerParam');
                visitorGaClientId = getGaClientId(this.options.googleAnalyticsAccount, ga);
            } catch (e) {
                console.log('error getting linkerParam');
            }
        }
        // chat mode can be specified explicitly
        chatMode = chatMode || this.options.chatMode;
        let { language } = me.options;
        if (languageOverride) {
            language = languageOverride;
        }
        // reading time from user's machine
        const now = new Date();
        const nowUtc = new Date(
            now.getUTCFullYear(),
            now.getUTCMonth(),
            now.getUTCDate(),
            now.getUTCHours(),
            now.getUTCMinutes(),
            now.getUTCSeconds()
        );
        // getting offset from utc for time calculations (to show with chat )
        let offset = new Date().getTimezoneOffset();
        // set offset to a negative if current time is less than utc
        if (nowUtc > now) {
            offset = -offset;
        }
        let guid = '';
        let isFirstChat = false;
        let isThirdParty = false;
        // get history cookie; create one if not already there
        if (getGuid) {
            guid = getCookieValue(TempCache.VISITOR_HISTORY_COOKIE);
            if (!guid) {
                // if our cookie doesn't exist yet, it's a new chat
                isFirstChat = true;
                // if the RL cookie exists, use that, but it's still the first chat
                guid = getCookieValue(TempCache.RL_VISITOR_HISTORY_COOKIE);
                if (guid) {
                    isThirdParty = true;
                }
            }
            if (!guid) {
                // generate guid if there isn't one of ours and isn't one from RL
                guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                    const r = (Math.random() * 16) | 0;
                    const v = c == 'x' ? r : (r & 0x3) | 0x8;
                    return v.toString(16);
                });
            }
            // set expiration date to one year ahead of current date
            Cookies.set(TempCache.VISITOR_HISTORY_COOKIE, guid, 365);
        }

        const match = RegExp('[?&]' + 'gclid' + '=([^&]*)').exec(window.location.search);
        let gclid = match && decodeURIComponent(match[1].replace(/\+/g, ' '));
        // if gclid=null; we need this otherwise the value in c# is interpreted as the string 'null'
        if (!gclid) {
            gclid = '';
        }
        // JIRA - 6451 - Greeting not appearing.
        // summary: Can't see greetings if chat started from PreChat too quickly before popup messages.
        // checking IF Prechat message popup appeared (IF YES: DONT SHOW Greeting)
        const isAlreadyPreChatMessageAppeared = storageAPIExists(
            TempCache.APEXCHAT_PRECHAT_MESSAGE_IDS_COOKIE
        );
        // checking IF Prechat message was sent previously and had complete chat session & ended chat
        const previouslyPreChatMessagesSent = !storageAPIExists(TempCache.PreChat_Message_Sent);
        // checking IF Chat session was ended
        const previousChatSessionEnded = !storageAPIExists(TempCache.CHAT_ID_COOKIE);
        const shouldGreetingAppear =
            !isAlreadyPreChatMessageAppeared &&
            previouslyPreChatMessagesSent &&
            previousChatSessionEnded;
        let params =
            `chatMode=${chatMode}&isVisitorFormEnabled=${this.options.requestVisitorInfo
            }&visitorId=${this.options.visitorId || Cookies.get(TempCache.VISITOR_ID_COOKIE) || 0 // todo: check if we can improve this
            }&companyId=${this.options.companyId}&companyKey=${this.options.companyKey
            }&requestedAgentId=${this.options.agentAliasId // REMOVE AFTER 2013 - not used anymore, for backwards compatibility during beta ONLY
            }&requestedAgentAliasId=${this.options.agentAliasId}&alreadyLoadedJS=false` + // ((window.fm && window.fm.websync) ? 'true' : 'false') +
            `&overrideHandlerId=${this.options.overrideHandlerId}&cb=${new Date().getTime()
            // we only take the first 1000 characters in the referrer to make sure we avoid problems with long urls
            }&timeZoneOffset=${offset}&guid=${guid}&profileId=${this.options.profileId == 0 ? this.options.profileID : this.options.profileId // hack to handle invitiation Vs preloaded handlers' naming mal-practice
            }&isFirstChat=${isFirstChat}&isThirdParty=${isThirdParty}&requestedOperatorId=${this.options.operatorId
            }&originalReferrer=${encodeURIComponent(document.referrer).substring(
                0,
                1000
            )}&referrer=${encodeURIComponent(window.location.href).substring(0, 1000)
            // getting rid of this parameter as it was interfering with cross domain tracking
            // '&gclid=' + gclid +
            }&language=${language}&gaclient=${ApexChat.gaClientId}&enableChatWindowCloseWarning=${this.options.enableChatWindowCloseWarning
            }&shouldGreetingMessageAppear=${shouldGreetingAppear}&prechatids=${getCookieValue(
                TempCache.APEXCHAT_PRECHAT_MESSAGE_IDS_COOKIE
            )}&${linkerParam}&visitorGaClient=${visitorGaClientId}`;
        if (getCookieValue(TempCache.CHAT_ID_COOKIE)) {
            params += `&chatId=${getCookieValue(TempCache.CHAT_ID_COOKIE)}`;
        }
        if (this.options.companyChatbot) {
            params += `&chatbotId=${this.options.companyChatbot.id}`;
        }
        if (me.options.videoGreetEnabled) {
            params += '&videoGreetWatchTime=' + ApexChat.options.videoGreetWatchTime;
        }
        if (getCookieValue(TempCache.SUBSEQUENT_GREETING_COOKIE)) {
            params += `&subsequent_greeting_flag=${getCookieValue(
                TempCache.SUBSEQUENT_GREETING_COOKIE
            )}`;
        }
        me.invokeChatInterceptor(); // Go idea to invoke chat interceptor before getting it's value
        params += `&_userSetting_=${encodeURIComponent(me.interceptorResults || additionalParams)}`; // Ref. Bug/CHAT-6705

        const trafficCookie = getCookieValue('livechat_invitation_traffic_sources');
        if (trafficCookie) {
            params += `&invitation_traffic_sources=${encodeURIComponent(trafficCookie)}`;
        }
        return params;
    }

    async extend_$() {
        // this the place to plugin custom functionality in our non-conflict jQuery
        const me = this;
        /* to check if jquery event is bound or not */
        // me.$.fn.isEventAlreadyBound = function (type) {
        //     const data = me.$._data(me.$(this)[0], 'events');

        //     if (data === undefined || data[type] === undefined || data.length === 0) {
        //         return false;
        //     }
        //     return true;
        // };
        // me.$.fn.jqDragger = function (h, o) {
        //     const jqDnRr = {
        //         dnr: {},
        //         e: 0,
        //         drag(v) {
        //             // console.log(v.data);
        //             const trans = v.data.transform
        //                 ? 'transform: translate(-50%, -50%) !important'
        //                 : '';
        //             Ele.css(
        //                 'cssText',
        //                 `position: fixed;z-index: 99999999;${trans};left: ${M.X + v.pageX - M.pX
        //                 }px !important; top: ${M.Y + v.pageY - M.pY}px !important; right: auto;`
        //             );
        //             v.data.moved = true;
        //             if (v.data.move) {
        //                 v.data.move(v);
        //             }
        //             return false;
        //         },
        //         stop(v) {
        //             Ele.css('opacity', 1);
        //             me.$(document.body).unbind('mousemove', J.drag).unbind('mouseup', J.stop);
        //             if (v.data.stop) {
        //                 v.data.stop(v);
        //             }
        //         }
        //     };
        //     var J = jqDnRr;
        //     var M = J.dnr;
        //     var Ele = J.e;
        //     const i = function (e, h, o) {
        //         return e.each(() => {
        //             h = h ? me.$(h) : e;
        //             h.bind('mousedown', { e, o }, (v) => {
        //                 const d = v.data;
        //                 const p = {};
        //                 Ele = d.e;
        //                 if (Ele.css('position') != 'relative') {
        //                     try {
        //                         Ele.position(p);
        //                     } catch (e) { }
        //                 }
        //                 M = {
        //                     X: p.left || f('left') || 0,
        //                     Y: p.top || f('top') || 0,
        //                     W: f('width') || Ele[0].scrollWidth || 0,
        //                     H: f('height') || Ele[0].scrollHeight || 0,
        //                     pX: v.pageX,
        //                     pY: v.pageY,
        //                     k: d.k,
        //                     o: Ele.css('opacity')
        //                 };
        //                 Ele.css({ opacity: 0.8 });
        //                 me.$(document.body).mousemove(o, jqDnRr.drag).mouseup(o, jqDnRr.stop);
        //                 return false;
        //             });
        //             if (o.start) {
        //                 o.start();
        //             }
        //         });
        //     };
        //     var f = function (k) {
        //         return parseInt(Ele.css(k)) || false;
        //     };

        //     return i(this, h, o);
        // };
        // (me.$.fn.isDisabled = function () {
        //     return me.$(this).is(':disabled') || me.$(this).css('pointer-events') == 'none';
        // }),
        //     (me.$.fn.disable = function (options) {
        //         const settings = me.$.extend(
        //             {
        //                 // These are the defaults.
        //                 recursively: false,
        //                 applyGrayBackground: false
        //             },
        //             options
        //         );
        //         if (settings.applyGrayBackground) {
        //             me.$(this).addClass('apexchat_disabled_element');
        //         }
        //         if (settings && settings.elementQT) {
        //             // select multi choice option in list
        //             me.$(this)
        //                 .prop('disabled', true)
        //                 .css('pointer-events', 'none')
        //                 .children()
        //                 .prop('tabindex', settings.tabIndex == 0 ? '0' : '-1');
        //         } else {
        //             /* When question types are disabled remove the tabinedex on the elements. */
        //             me.$(this).prop('disabled', true).css('pointer-events', 'none');
        //         }
        //         if (settings.recursively) {
        //             me.$(this)
        //                 .children()
        //                 .each(function (index) {
        //                     me.$(this).disable(settings.recursively);
        //                 });
        //         }
        //         return this; // to allow method chaining
        //     });
        // me.$.fn.enable = function (recursively) {
        //     me.$(this).prop('disabled', false).css('pointer-events', 'auto');
        //     me.$(this).removeClass('apexchat_disabled_element');
        //     if (recursively) {
        //         me.$(this)
        //             .children()
        //             .each(function (index) {
        //                 me.$(this).enable(recursively);
        //             });
        //     }
        //     return this; // to allow method chaining
        // };
        // // applies on a select
        // me.$.fn.populateSelectList = function (
        //     options /* [{ value:'option value', text:'option text' },...] */
        // ) {
        //     const $dropdown = this;
        //     me.$.each(options, function () {
        //         $dropdown.append(me.$('<option />').val(this.value).text(this.text));
        //     });
        // };
        // me.$.fn.showValidationTooltip = function (config) {
        //     // to show tooltip just pass tooltip text and css class name
        //     if (!(config && config.toolTipText)) {
        //         return;
        //     }
        //     if (config.isPreChatText) {
        //         me.$(this)
        //             .closest('.apexchat_question_type_single_col')
        //             .find('.apexchat_error_msg')
        //             .remove(); // removing the previous summary.
        //         me.$(this).closest('.apexchat_rd_prechat_input').addClass(config.toolTipCss);
        //         // appending new sumamry.
        //         me.$(this)
        //             .closest('.apexchat_question_type_single_col')
        //             .append(
        //                 `<div class="apexchat_error_msg" title="${config.toolTipText}" tabindex="0">${config.toolTipText}</div>`
        //             );
        //     } else {
        //         me.$(this).find(`span.${config.toolTipCss}_text`).remove();
        //         me.$(this).addClass(config.toolTipCss);
        //         me.$(this).append(
        //             `<span class="${config.toolTipCss}_text" title="${config.toolTipText}" tabindex="0">${config.toolTipText}</span>`
        //         );
        //     }
        //     return this;
        // };
        // me.$.fn.removeValidationTooltip = function (config) {
        //     // to remove tooltip just pass tooltip css class name
        //     if (!(config && config.toolTipCss)) {
        //         return;
        //     }
        //     me.$(this).find(`span.${config.toolTipCss}_text`).remove();
        //     me.$(this).removeClass(config.toolTipCss);
        //     return this;
        // };
        // me.$.fn.preventTyping = function () {
        //     // prevent user to type anything.
        //     // as for mobile browser, only keyup event works for on screen keyboard so we used keyup event to prevent typing
        //     me.$(this).keyup(function (e) {
        //         me.$(this).val('');
        //     });
        //     return this;
        // };
        // me.$.fn.allowTyping = function () {
        //     // allow user to type anything.
        //     // reverting its functionality to normal keyup
        //     me.$(this).unbind('keyup').keyup();
        //     return this;
        // };
        // initialize custom dropdown for MC; ref CHAT-4778
        // const module = await import(/* webpackChunkName: "dropSelect" */ '../../libs/dropSelect')
        // const pluginDropSelect = module.default;
        // pluginDropSelect(me.$);
        // initialize custom behavior for resizable textarea; ref CHAT-5375
        // ApexChat.pluginFlexTextArea(me.$);
    }

    formArrayToJson(formArray) {
        const me = this;
        const o = {};
        me.$.each(formArray, function () {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    }

    // util methods to set/get selected item in the new dropSelect
    setSelectedDropdownItem(element, option) {
        const selectedItem = element.find(`div.dropSelect-items-wrapper a[data-value="${option}"]`);
        if (selectedItem) {
            selectedItem.click();
        }
    }

    getSelectedDropdownItem(element) {
        return element.find('.selected').attr('data-value');
    }

    hasBeenShown() {
        // There should be INVITATION_SHOWN Cookie: TRUE
        return storageAPIExists(TempCache.INVITATION_SHOWN);
    }

    setShown() {
        const me = this;
        // once the invitation has dropped, show it minimized from then on
        if (!this.hasBeenShown()) {
            ApexChat.storageAPI.StoreUntil(TempCache.INVITATION_SHOWN, true, {
                timeType: TimeType.Minute,
                expiringDuration: me.options.reShowIntervalMinutes
            });
        }
    }

    getContextId(context) {
        // get context widget id
        const DOM = (context || this.context).getElementById(`${WidgetTypes.DOM}_max`);
        const Windowed = (context || this.context).getElementById(`${WidgetTypes.Windowed}_max`);
        const EP = (context || this.context).getElementById(`${WidgetTypes.ExitPopup}_max`);
        return DOM ? DOM.id : Windowed ? Windowed.id : EP.id;
    }

    isTransferredToLiveAgent() {
        const value = Cookies.get(TempCache.TRANSFER_TO_LIVE_AGENT);
        if (value) {
            return ApexChat.TryParse(Cookies.get(TempCache.TRANSFER_TO_LIVE_AGENT)); // get TransferToLiveAgent flag if chat transfer from scriptbot to livechat
        }
        return false;
    }

    isOperatorActive(options) {
        return options.model.isOperatorAvailable;
    }

    setTransferredToLiveAgent() {
        Cookies.set(TempCache.TRANSFER_TO_LIVE_AGENT, true); // set cookies so we could maintain its state.
    }

    isMobile() {
        return this.options.isMobile || Browser.isiOS() || Browser.isAndroid();
    }

    isWindowedStarted() {
        return getStorageAPIValue('livechat_has_windowed_chat_started') == 'true';
    }

    getQTPlaceHolder(questionType) {
        // get Question Type placeholders
        const me = this;
        switch (questionType) {
            case ScriptsQuestionType.MultipleChoice:
                return checkSpanishLanguage(me.options)
                    ? ScriptsQuestionTypeToolTips.Spa.MC
                    : ScriptsQuestionTypeToolTips.Eng.MC;
            case ScriptsQuestionType.TrueOrFalse:
                return checkSpanishLanguage(me.options)
                    ? ScriptsQuestionTypeToolTips.Spa.TrueFalse
                    : ScriptsQuestionTypeToolTips.Eng.TrueFalse;
            case ScriptsQuestionType.Text:
                return checkSpanishLanguage(me.options)
                    ? ScriptsQuestionTypeToolTips.Spa.Text
                    : ScriptsQuestionTypeToolTips.Eng.Text;
            case ScriptsQuestionType.Time:
                return checkSpanishLanguage(me.options)
                    ? ScriptsQuestionTypeToolTips.Spa.Date
                    : ScriptsQuestionTypeToolTips.Eng.Time;
            case ScriptsQuestionType.TimeCalendar:
                return checkSpanishLanguage(me.options)
                    ? ScriptsQuestionTypeToolTips.Spa.DateTime
                    : ScriptsQuestionTypeToolTips.Eng.DateTime;
            case ScriptsQuestionType.CalendarDate:
                return checkSpanishLanguage(me.options)
                    ? ScriptsQuestionTypeToolTips.Spa.Date
                    : ScriptsQuestionTypeToolTips.Eng.Date;
            case ScriptsQuestionType.AllThatApply:
                return checkSpanishLanguage(me.options)
                    ? ScriptsQuestionTypeToolTips.Spa.AllThatApply
                    : ScriptsQuestionTypeToolTips.Eng.AllThatApply;
            case ScriptsQuestionType.AppointmentScheduler:
                return checkSpanishLanguage(me.options)
                    ? ScriptsQuestionTypeToolTips.Spa.AppointmentSchedule
                    : ScriptsQuestionTypeToolTips.Eng.AppointmentSchedule;
            default:
                return checkSpanishLanguage(me.options)
                    ? ScriptsQuestionTypeToolTips.Spa.FTMessage
                    : ScriptsQuestionTypeToolTips.Eng.FTMessage;
        }
    }

    getOptionStyles(options, id, optionId) {
        const me = this;
        if (options) {
            let styles = '';
            let fStyle = '';
            const qtButton = `.apexchat_qt_button_${id}_${optionId}`;
            if (options.backgroundColor) {
                styles += `background-color:${options.backgroundColor} !important;`;
            }
            if (options.borderColor) {
                styles += ` border-color:${options.borderColor} !important;`;
            }
            if (options.fontStyle) {
                const fontStyle = JSON.parse(options.fontStyle);
                fStyle += ` font-weight:${fontStyle.bold ? 'bold' : 'normal'} !important;`;
                fStyle += ` font-style:${fontStyle.italic ? 'italic' : 'normal'} !important;`;
                fStyle += ` text-decoration:${fontStyle.underline ? 'underline' : 'none'
                    } !important;`;
                if (fontStyle.family) {
                    fStyle += ` font-family:${fontStyle.family.replaceAll('"', '')} !important;`;
                }
                fStyle += ` font-size:${fontStyle.size ? fontStyle.size : '14px'} !important;`;
                if (fontStyle.color) {
                    fStyle += ` color:${fontStyle.color} !important;`;
                }
                if (me.options.widgetType === WidgetTypes.PreChat) {
                    styles += fStyle;
                }
            }
            if (options.hoverColor) {
                RunAsSoonAs(
                    () => {
                        me.$(qtButton, me.context)
                            .mouseenter(() => {
                                me.$(qtButton, me.context).attr('style', (i, s) => {
                                    const bg = s.replace(
                                        options.backgroundColor,
                                        options.hoverColor
                                    );
                                    return bg || '';
                                });
                            })
                            .mouseleave(() => {
                                me.$(qtButton, me.context).attr('style', (i, s) => {
                                    const bg = s.replace(
                                        options.hoverColor,
                                        options.backgroundColor
                                    );
                                    return bg || '';
                                });
                            });
                    },
                    () => me.$(qtButton, me.context).is(':visible')
                );
            }
            return { styles, fontStyle: fStyle };
        }
    }

    handleSmsBottomSheetToggle(smsBottomSheet) {
        const me = this;
        const smsBottomSheetInner = me.$('.livechat_bottomSheet_for_sms_chat_inner', me.context);
        const bottomSheetEPBackdrop = me.$('.popover_backdrop', me.context);
        const bottomSheetEPBackdropWrapper = me.$('.popover_backdrop_wrapper', me.context);
        if (smsBottomSheet.is(':visible')) {
            setTimeout(() => {
                smsBottomSheet.hide();
                bottomSheetEPBackdropWrapper.hide();
            }, 500)
        } else {
            smsBottomSheet.show();
            bottomSheetEPBackdropWrapper.show();
        }
        smsBottomSheetInner.toggleClass(
            'apexchat_bottom_sheet_slide_in apexchat_bottom_sheet_slide_out'
        );
        const wrapper = me.$('.apex-wrapper', me.context);
        bottomSheetEPBackdrop
            .css({
                width: wrapper.outerWidth(),
                height: wrapper.outerHeight()
            })
            .toggleClass('show_backdrop');
        if (smsBottomSheetInner.hasClass('apexchat_bottom_sheet_slide_in')) {
            ApexChat.localStorageAPI.Store('sms_bottomsheet_opened', true);
        } else {
            ApexChat.localStorageAPI.Remove('sms_bottomsheet_opened');
        }
    }

    toggleSmsBottomSheet() {
        const me = this;
        if (!me.$) {
            me.$ = ApexChat.ApexChatJquery;
        }
        const smsBottomSheet = me.$('.open_sms_bottom_sheet', me.context);
        me.handleSmsBottomSheetToggle(smsBottomSheet);
        const phonemsg = me.getPhoneMessage();
        if (phonemsg && phonemsg.phone) {
            smsBottomSheet.find("[name='phone']").val(phonemsg.phone);
        }
    }
    checkConvertToSms(selection) {
        const me = this;
        if (
            selection &&
            selection.actions?.some((x) => x.actionType === AgentScriptActionType.convertToSMS)
        ) {
            me.toggleSmsBottomSheet();
        }
    }

    getSelectedOption(selectedText, msgObj) {
        let options = msgObj.agentScriptOptions || msgObj.options;
        if (!options) {
            return null;
        }
        if (typeof msgObj.options === 'string') {
            options = JSON.parse(msgObj.options);
        }
        return options.filter((x) => x.text == selectedText)[0];
    }
}
